module.exports = __webpack_public_path__ + "img/logo-avatar.1571b8e3.png";